import {PATH_DASHBOARD} from '@feg/ui'
import {useTranslation} from 'react-i18next'
import CountryRegionList from '../../../components/admin/countryRegion/CountryRegionList'
import AddEditCountryRegionButton from '../../../components/admin/countryRegion/AddEditCountryRegionButton'
import {PageRoot} from "@feg/ui/src/common/layout/PageRoot";


export default function RegionPage() {
    const {t} = useTranslation()
    return (
        <PageRoot title={t('countryRegion.list.main')}
                  breadcrumbs={{
                      heading: t('countryRegion.list.main'),
                      links: [
                          {name: t('dashboard.main'), href: PATH_DASHBOARD.general.app},
                          {name: t('countryRegion.list.main'), href: PATH_DASHBOARD.location.countryRegion}
                      ],
                      action: (
                          <AddEditCountryRegionButton/>
                      )
                  }}>
            <CountryRegionList/>
        </PageRoot>
    )
}

